import { useCallback, useEffect, useState } from 'react';
import {
  fetchSellerPlanAccess,
  hasSellerPlanFeature
} from '../services/membershipPlanService';

const useSellerPlanAccess = (sellerId) => {
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(Boolean(sellerId));
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!sellerId) {
      setAccess(null);
      setLoading(false);
      return null;
    }

    setLoading(true);
    setError('');

    try {
      const currentAccess = await fetchSellerPlanAccess();
      setAccess(currentAccess);
      return currentAccess;
    } catch (requestError) {
      setError(requestError.message || 'Unable to load seller plan access.');
      return null;
    } finally {
      setLoading(false);
    }
  }, [sellerId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const hasFeature = useCallback(
    (featureKey) => hasSellerPlanFeature(access, featureKey),
    [access]
  );

  return { access, loading, error, refresh, hasFeature };
};

export default useSellerPlanAccess;
